import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import _ from "lodash";


import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { selectTermsLibrariesQueryItems } from "../../redux/terms-libraries/selector";
import { selectSectionsQueryItems } from "../../redux/sections/selector";
import { sections } from "../../redux/sections/action";
import { termsLibraries } from "../../redux/terms-libraries/action";
import PageLoader from "../PageLoader";
import { HTMLContent } from "../../common/components/html-content";

export const Terms = () => {
    const dispatch = useAppDispatch();
    const { height, width } = useWindowDimensions();
    const termsLibrariesQuery: any = useSelector(selectTermsLibrariesQueryItems)
    const sectionQueryItems: any = useSelector(selectSectionsQueryItems);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [termsData, setTermsData] = useState<any>({})
    const parmas = useParams()


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        getTerms();


    }, [parmas?.id])

    const sectionQuery = async () => {
        await dispatch(sections.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/terms-library/sections/query`, entity: 'sections', jsonData:
            {
                "Records": [
                    {
                        "Id": termsLibrariesQuery?.result?.items?.SectionIds[0]
                    }
                ]
            }
        }))
        await dispatch(termsLibraries.resetAction({ actionType: 'query' }))
    }
    useEffect(() => {
        if (termsLibrariesQuery?.isSuccess && termsLibrariesQuery?.result?.items?.SectionIds.length > 0) {
            sectionQuery()
        }
    }, [termsLibrariesQuery]);

    const TermsData = async () => {
        await setTermsData(sectionQueryItems?.result?.items)
        await dispatch(sections.resetAction({ actionType: 'query' }))
        await setIsLoading(false)
    }
    useEffect(() => {
        if (sectionQueryItems?.isSuccess && sectionQueryItems?.result?.items) {
            TermsData()
        }
    }, [sectionQueryItems]);

    const getTerms = async () => {
        await setIsLoading(true)
        await dispatch(termsLibraries.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/query`, entity: 'termsLibraries', jsonData:
            {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        }));
    }

    return (
        <>
            {isLoading ? <PageLoader />
                :
                <>
                    {width && width < 720 ?
                        <div className="scrollbar-hide overflow-y-auto flex flex-col bg-white px-4 py-24 rounded-lg shadow-lg max-h-screen ">
                            {/* Title Section */}
                            <div className="text-xl sm:text-2xl font-semibold text-gray-800 border-b pb-3 mb-4">
                                Terms & Conditions
                            </div>

                            {/* Content Section */}
                            <div className="w-full">
                                <div className="w-full bg-white">
                                    <div className="text-lg font-medium text-gray-900 uppercase px-4 py-3 sm:p-6">
                                        {termsData?.Name || 'Terms & Conditions'}
                                    </div>
                                    <div className="text-gray-700 leading-relaxed px-4 sm:px-6 pb-4 text-justify sm:pb-6">
                                        {termsData && <HTMLContent htmlContent={termsData.Description} />}
                                    </div>
                                </div>
                            </div>
                        </div> :
                        <div className="overflow-y-auto flex flex-col bg-white px-16 py-10 rounded-lg shadow-lg">
                            {/* Title Section */}
                            <div className="text-2xl font-semibold text-gray-800 border-b pb-4 mb-6">
                                Terms & Conditions
                            </div>

                            {/* Content Section */}
                            <div className="w-full">
                                <div className="w-full bg-white">
                                    <div className="text-lg font-medium text-gray-900 uppercase p-6">
                                        {termsData?.Name ? termsData.Name : 'Terms & Conditions'}
                                    </div>
                                    <div className="text-gray-700 leading-relaxed px-6 pb-6 text-justify">
                                        {termsData && <HTMLContent htmlContent={termsData.Description} />}
                                    </div>
                                </div>
                            </div>
                        </div>}</>
            }
        </>
    )
}

